import { Components, Theme } from '@mui/material'

export const PaginationOverrides = (
  theme: Theme
): Components['MuiPagination'] => ({
  defaultProps: {},
  styleOverrides: {
    root: { alignItems: 'center', justifyContent: 'center' },
    ul: {
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
})

export const PaginationItemOverrides = (
  theme: Theme
): Components['MuiPaginationItem'] => ({
  defaultProps: {},
  styleOverrides: {
    root: {},
    rounded: {
      borderRadius: 0,
      width: '56px',
      height: '56px',
      '&.Mui-selected, &.Mui-selected:hover, :hover': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.background.secondary,
      },
      fontWeight: 700,
    },
    previousNext: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.background.primary,
      ':hover': {
        backgroundColor: theme.palette.background.secondary,
      },
    },
  },
})
